"use client";

var __jsx = React.createElement;
import entityBrandingStoryblokService from "@lib/storyblok/services/financial-entity-services/entity-branding-service";
import React from "react";
import StoryblokLogo from "@modules/shared/logos/template/storyblok-logo";
export const BancogralFooterLogo = _ref => {
  let {
    height,
    className,
    maxWidth
  } = _ref;
  return __jsx(StoryblokLogo, {
    height: height,
    style: {
      height: height,
      maxWidth: maxWidth
    },
    className: className,
    srcGetter: async () => await entityBrandingStoryblokService.getFooterLogo(),
    cacheKey: "footer_logo",
    alt: "Footer Logo"
  });
};
export const BancogralContrastFooterLogo = _ref2 => {
  let {
    height,
    className,
    maxWidth
  } = _ref2;
  return __jsx(StoryblokLogo, {
    height: height,
    style: {
      height: height,
      maxWidth: maxWidth
    },
    className: className,
    srcGetter: async () => await entityBrandingStoryblokService.getFooterContrastLogo(),
    alt: "Footer Logo"
  });
};